import React from 'react';
import moment from 'moment';

import PopupContainer from 'onboarding/common/forms/common/Popup';

class TimePickerBtn extends React.Component {
  static defaultProps = {
    onOpenTimeChange: () => {},
    onCloseTimeChange: () => {},
  };

  constructor(props) {
    super(props);

    const selectedHour = moment(props.defaultTime, 'hh:mm:ss').format('hh:mm a');

    const hours = props.hoursToShow.map((hour) => ({
      ...hour,
      active: props.defaultTime.format('hh:mm a') === hour.name,
    }));
    this.state = { hours, selectedHour, showPopup: false };
  }

  // noinspection JSCheckFunctionSignatures
  UNSAFE_componentWillReceiveProps(newProps) {
    let found = false;
    for (let i = 0; i < newProps.hoursToShow.length; i += 1) {
      if (newProps.hoursToShow[i].name === this.state.selectedHour) {
        found = true;
        break;
      }
    }
    if (newProps.hoursToShow && newProps.hoursToShow.length > 0 && !found) {
      this.setState({ selectedHour: newProps.hoursToShow[0].name });
    }
    this.setState({
      // eslint-disable-next-line arrow-body-style
      hours: newProps.hoursToShow.map((hour) => {
        return { ...hour, active: newProps.defaultTime.format('hh:mm a') === hour.name };
      }),
    });
  }

  onItemClick = (item) => {
    this.setState({ selectedHour: item.name });
    this.hidePopup();
    const newTime = moment(item.name, 'hh:mm a');
    if (this.props.onOpenTimeChange && newTime) {
      this.props.onOpenTimeChange(newTime);
    }
    if (this.props.onCloseTimeChange && newTime) {
      this.props.onCloseTimeChange(newTime);
    }
  };
  showPopup = () => {
    this.setState({ showPopup: true });
  };
  hidePopup = () => {
    this.setState({ showPopup: false });
  };

  render() {
    return (
      <div className="dropdown-mobile">
        <button className="time-picker-btn" onClick={this.showPopup}>
          <div className="time-picker-label">{this.props.label}</div>
          <div className="time-text">{this.state.selectedHour}</div>
        </button>
        {this.state.showPopup && <PopupContainer title={this.props.popupTitle} items={this.state.hours} onClose={this.hidePopup} onSelectItem={this.onItemClick} />}
      </div>
    );
  }
}

export default TimePickerBtn;
